import { render, staticRenderFns } from "./Azall.vue?vue&type=template&id=206cc233&scoped=true"
import script from "./Azall.vue?vue&type=script&lang=js"
export * from "./Azall.vue?vue&type=script&lang=js"
import style0 from "./Azall.vue?vue&type=style&index=0&id=206cc233&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206cc233",
  null
  
)

export default component.exports